import { AdminUser } from '../../pm/types';
import { displayName } from '../../pm/constants';

interface Props {
  admins: AdminUser[];
  selectedIndex: number;
  onPick: (admin: AdminUser) => void;
  onHover: (index: number) => void;
}

const MentionPicker: React.FC<Props> = ({ admins, selectedIndex, onPick, onHover }) => {
  if (admins.length === 0) {
    return (
      <div className="pm-mention-menu">
        <div className="pm-mention-empty">No matches</div>
      </div>
    );
  }

  return (
    <div className="pm-mention-menu">
      {admins.map((a, i) => (
        <button
          key={a.uid}
          type="button"
          className={i === selectedIndex ? 'active' : ''}
          onMouseDown={(e) => {
            // mousedown not click so it fires before textarea blur
            e.preventDefault();
            onPick(a);
          }}
          onMouseEnter={() => onHover(i)}
        >
          <span className="pm-mention-name">{displayName(a.email)}</span>
          <span className="pm-mention-email">{a.email}</span>
        </button>
      ))}
    </div>
  );
};

export default MentionPicker;
